import { useI18n } from "../i18n/I18nProvider";
import { IconMetro, IconParking, IconRoad } from "./icons";

/**
 * Frame 5:26 (desktop) and 5:161 (mobile) list parking, airport road, metro in
 * that order from the left edge in both locales, so the row is pinned to
 * left-to-right. Desktop prints one bold line plus a caption; mobile prints the
 * value and the short label on separate lines.
 */
export function QuickFacts() {
  const { copy, direction } = useI18n();
  const stats = [
    { key: "parking", icon: <IconParking />, ...copy.stats.parking },
    { key: "airport", icon: <IconRoad />, ...copy.stats.airport },
    { key: "metro", icon: <IconMetro />, ...copy.stats.metro },
  ];

  return (
    <section className="bg-white" aria-label={copy.stats.parking.title}>
      <div
        dir="ltr"
        className="flex items-start justify-between gap-3 mx-auto w-full max-w-[1440px] px-[18px] lg:px-[72px] py-4 lg:min-h-[110px] lg:gap-[34px] lg:py-5"
      >
        {stats.map((stat) => (
          <div
            key={stat.key}
            dir={direction}
            data-reveal
            className="flex flex-1 flex-col items-center gap-[3px] text-center lg:gap-1"
          >
            <span className="text-[26px] text-icon lg:text-[28px]">{stat.icon}</span>
            <span className="hidden text-[24px] font-bold leading-[45px] text-navy lg:block">
              {stat.title}
            </span>
            <span className="text-[24px] font-bold leading-[45px] text-navy lg:hidden">
              {stat.value}
            </span>
            <span className="hidden text-[12px] font-medium leading-[22.5px] text-body lg:block">
              {stat.caption}
            </span>
            <span className="text-[12px] font-medium leading-[22.5px] text-body lg:hidden">
              {stat.label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
